
import * as React from 'react';
import { Button, Calendar, Card, Col, Flex, Form, Grid, Row, Space, Tag, Typography } from 'antd';
import Box from '../../../components/Box/Box';
import './index.scss';
import TeamCard from '../dashboard/common/TeamCard';
import FormSetup from '../../../components/Forms/FormSetup';
import projectConfigs from '../../../entity/projects/projectConfig';
import { FormColumnConfig, MasterConfigs } from '../../../interfaces/entity';
import InfiniteScrollList from '../../../components/Forms/ListView/InfiniteScrollList';
import { TeamOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux';
import { getData } from '../../../actions/apiCall';
import { FormInstance } from 'antd/lib';
import { constants } from '../../../constants/common';
import ProfileCard from '../../../components/ContactInfo/ProfileCard';
import { useNavigate } from 'react-router-dom';
const { Title, Text } = Typography;

export const getProjectStatus = (projectStatus) => {
    if (projectStatus == 'HOLD') {
        return <Tag bordered={false} color="orange">Hold</Tag>;
    } else if (projectStatus == 'ACTIVE') {
        return <Tag bordered={false} color="green">Active</Tag>;
    } else if (projectStatus == 'BLOKER') {
        return <Tag bordered={false} color="red">Bloker</Tag>;
    } else if (projectStatus == 'COMPLETED') {
        return <Tag bordered={false} color="green">Completed</Tag>;
    } else {
        return <Tag bordered={false} color="red">Not Started</Tag>;
    }
}

interface TeamsProps {
    _id: string;
    role: string;
    teamMember: {
        _id: string;
        firstName: string;
        lastName: string;
    }
}

const ProjectDashboard: React.FC = () => {
    const [visible, setVisible] = React.useState(false);
    const [counts, setCounts] = React.useState<{ count: number, name: string }[]>([]);
    const [refreshKey, setRefreshKey] = React.useState(0);
    const [addTeamVisible, setAddTeamVisible] = React.useState(false);
    const [form, setForm] = React.useState<FormInstance>(null);
    const [selectedTeam, setSelectedTeam] = React.useState<TeamsProps[]>([]);
    const [teamId, setTeamId] = React.useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    React.useEffect(() => {
        getCounts();
    }, []);

    const onRefresh = () => {
        setRefreshKey(refreshKey + 1);
    }

    const getFormColumns = (formItems) => {
        return projectConfigs.getFormColumns()
            .filter(e => formItems.includes(e.name))
    }

    const config: MasterConfigs = {
        ...projectConfigs,
        getFormColumns: () => [
            ...getFormColumns(['clientName', 'name',]),
            { span: 8 },
            ...getFormColumns(['startDate', 'endDate']),
            { span: 8 },
            {
                ...getFormColumns(['description'])[0],
                span: 16
            }
        ],
        onRefresh: () => onRefresh()
    };

    const onCancel = () => {
        setVisible(false);
    }

    const onPanelChange = () => {

    };

    const GetCard = ({ title, number }) => {
        return <Card >
            <Space className='justify_content' direction='horizontal' style={{ width: '100%' }}>
                <div>
                    {title}
                </div>
                <div>
                    {number}
                </div>
            </Space>
        </Card>;
    };

    React.useEffect(() => {
        if (teamId) {
            setAddTeamVisible(true);
        }
    }, [teamId]);

    const onAddTeam = (e) => {
        setTeamId(e)
    }

    const getCounts = async () => {
        const res = await dispatch(getData('/projects/summary/count'));
        if (res.code === 200) {
            console.log(res);
            setCounts(res.data);
        }
    }

    return (
        <>
            <FormSetup config={config} onClose={onCancel} isModal={true} open={visible} />
            <Row gutter={16} key={'list'}>
                <Col span={18}>
                    <Space direction='vertical' style={{ width: '100%' }}>
                        <Row gutter={[16, 16]}>
                            {counts?.map(ele => <Col className="gutter-row" span={24 / 3}>
                                <GetCard number={ele.count} title={ele.name} />
                            </Col>)}
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col className="gutter-row" span={24 / 2}>
                                <Box title='Teams'>
                                    <Space direction='vertical' style={{ width: '100%' }}>
                                        <InfiniteScrollList
                                            key={refreshKey}
                                            apiUrl={config.api()}
                                            height={300}
                                            renderItem={(item: any, index) => {
                                                return <div style={{ marginBottom: 10 }}>
                                                    <TeamCard
                                                        members={[item?.name, item?.name, item?.name]}
                                                        name={item?.name}
                                                    />
                                                </div>
                                            }}
                                        />
                                    </Space>
                                </Box>
                            </Col>
                            <Col className="gutter-row" span={24 / 2}>
                                <Box
                                    title='Projects'
                                    key={'projects'}
                                    actions={<Button onClick={() => setVisible(true)}>Add Projects</Button>}
                                >
                                    <InfiniteScrollList
                                        key={refreshKey}
                                        apiUrl={config.api()}
                                        height={300}
                                        renderItem={(item: any, index) => {
                                            return <Card style={{ marginBottom: 10 }} className='project-card'>
                                                <Flex justify='space-between'>
                                                    <Space direction='vertical'>
                                                        <Title level={5} style={{ lineHeight: 1.2, marginBottom: 0 }}>{item?.name}</Title>
                                                        <Space direction='horizontal'>
                                                            <Text type='secondary'>{item?.clientName}</Text>
                                                            {getProjectStatus(item?.projectStatus)}
                                                        </Space>
                                                    </Space>
                                                    <Flex justify='space-between' gap={60} align='center'>
                                                        <Button type='text' icon={<TeamOutlined />}>
                                                            23
                                                        </Button>
                                                        <Button type='default' onClick={() => navigate(`/tasks/${item?._id}/board`)}>Tasks</Button>
                                                    </Flex>
                                                </Flex>
                                            </Card>
                                        }}
                                        itemsPerPage={6}
                                    />
                                </Box>
                            </Col>
                        </Row>
                    </Space>
                </Col>
                <Col span={6}>
                    <Card>
                        <Calendar mode='month' fullscreen={false} onPanelChange={onPanelChange} />
                        <Space direction='vertical' style={{ width: '100%' }}>

                        </Space>
                    </Card>
                </Col>
            </Row>

        </>
    );
};

export default ProjectDashboard;
